import * as yup from 'yup'

const schema = yup.object().shape({
  name: yup.string().trim().max(255).required(),
  description: yup.string().max(3000),
})

export default schema
